import React from "react";
import { useNavigate } from "react-router-dom";
import $ from "jquery";
import { TextField } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import Input from "@mui/material/Input";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { fetchApi } from "../../../helper/api";
import { IsAlert } from "../../atoms/IsAlert";

const InputUser = (props) => {
  const navigate = useNavigate();
  const [values, setValues] = React.useState({
    amount: "",
    username: "",
    password: "",
    weight: "",
    weightRange: "",
    showPassword: false,
    errorMessage: "",
  });
  const handleChange = (prop) => (event) => {
    setValues({ ...values, [prop]: event.target.value });
  };

  const handleClickShowPassword = () => {
    setValues({
      ...values,
      showPassword: !values.showPassword,
    });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  const handleUsername = (e) => {
    var username_val = e.target.value;
    setValues({
      ...values,
      username: username_val,
    });
  };

  const handleSubmit = async () => {
    var dataPost = {
      email: values.username,
      password: values.password,
    };
    var req = await fetchApi("api/User/regViaAdmin", "POST", true, dataPost);
    var status = req.status;
    var res = await req.json();
    $(".close").click();
    if (status !== 200) {
      IsAlert.fire({
        title: res.status,
        text: res.message,
        icon: "error",
        showCancelButton: false,
        focusConfirm: true,
        confirmButtonText: "OK",
        showCancelButton: false,
      }).then(function (isConfirm) {
        if (isConfirm.isConfirmed) {
        }
      });
    } else {
      IsAlert.fire({
        title: res.status,
        text: res.message,
        icon: "success",
        showCancelButton: false,
        focusConfirm: true,
        confirmButtonText: "OK",
        showCancelButton: false,
      }).then(function (isConfirm) {
        if (isConfirm.isConfirmed) {
          props.reloadData();
        }
      });
    }
  };
  return (
    <div
      className="modal fade"
      id="InputUser_modal"
      tabIndex={-1}
      aria-labelledby="InputUser_modalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-sm">
        <div className="modal-content">
          <div className="modal-header">
            <div className="d-flex align-items-center">
              <h5 className="mb-0 ml-2">Input Data User</h5>
            </div>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div className="modal-body">
            <form className="p-1">
              <div className="py-2">
                <TextField
                  onChange={handleUsername}
                  value={values.username}
                  className="w-100"
                  label="Username / Email"
                  variant="standard"
                  autoComplete="off"
                />
              </div>
              <div className="py-2">
                <FormControl sx={{ width: "100%" }} variant="standard">
                  <InputLabel htmlFor="standard-adornment-password">
                    Password
                  </InputLabel>
                  <Input
                    id="standard-adornment-password"
                    type={values.showPassword ? "text" : "password"}
                    value={values.password}
                    onChange={handleChange("password")}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                          onMouseDown={handleMouseDownPassword}
                        >
                          {values.showPassword ? (
                            <VisibilityOff />
                          ) : (
                            <Visibility />
                          )}
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                </FormControl>
              </div>
            </form>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-success"
              onClick={handleSubmit}
            >
              Simpan
            </button>
            <button
              type="button"
              className="btn btn-light"
              data-dismiss="modal"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default InputUser;
